import React from 'react';
import { Grid, Paper, Typography, Tooltip, IconButton, Divider } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { InlineAlert } from "common/alerts";
import { LoginStyles } from '../../../customStyles';
import { AlertStyles } from "../../../customStyles/common";
import { DividerStyle } from "../../../customStyles/common";
import { AlertColor } from '../../../customEnums/AlertColor';

interface SetUpMFAComponentProps {
  authCode: {
    auth?: string;
    text?: string;
  };
  copyText: () => void;
  copySuccess: string;
}

export const SetUpMFAComponent: React.FC<SetUpMFAComponentProps> = ({ authCode, copyText, copySuccess }) => {
  return (
    <>
      <Grid container display='flex' justifyContent='center' alignItems='center'>
        <Paper sx={LoginStyles.qrCodeStyle}>
          <QRCodeSVG
            size={175}
            value={
              authCode.auth
                ? authCode.auth
                : `otpauth://totp/AWSCognito:" + user.username + "?secret=" + res + "&issuer=Cognito`
            }
          />
        </Paper>
      </Grid>
      <span style={LoginStyles.authCodeContainerStyle}>
        <span style={LoginStyles.authCodeTextStyle as React.CSSProperties}>
          <Typography sx={LoginStyles.qrCodeVerificationStyle}>
            {authCode.text}
          </Typography>
        </span>
        <Tooltip title="Copy">
          <IconButton aria-label="Copy" sx={{ color: "#A1A1A5", marginLeft: '0.5rem' }} onClick={copyText}>
            <CopyAllIcon />
          </IconButton>
        </Tooltip>
        <p style={LoginStyles.copySuccessStyle}>
          {copySuccess}
        </p>
      </span>
      <InlineAlert
        severity={AlertColor.INFO}
        title="Save the setup key or QR code for recovery."
        message="Use the setup key or QR code to reset MFA access. Do not share this setup key or QR code with anyone"
        sx={{ ...AlertStyles.info, mb: '0.5rem' }}
      />
      <Divider style={DividerStyle} aria-hidden role="separator" />
      <Grid container display='flex' justifyContent='center'>
        <Typography variant='subtitle1'>Enter verification code</Typography>
      </Grid>
    </>
  );
};